module.exports = __webpack_public_path__ + "img/custom.819446fb.svg";